<div class="flex-fill d-flex flex-column">
    <h1 class="header-label">Storage and Dump Sites</h1>
    <div class="flex-fill content-block dx-card responsive-paddings">
        <div class="d-flex flex-fill">
            <dx-data-grid
                #overviewGrid
                keyExpr="id"
                [dataSource]="storageDumpSites"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onRowDblClick)="rowDoubleClick($event)"
            >
                <dxi-data-grid-column dataField="name" width="150"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="dump" width="75"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="storage" width="75"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="tonExpense.name" caption="Ton Expense" width="75"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="note" width="250"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="address1" width="200"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="address2" width="200"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="city" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="state" width="75"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="zip" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="country" width="75"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="latitude" alignment="left" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="longitude" alignment="left" width="100"></dxi-data-grid-column>
                <dxi-data-grid-column dataField="displayDumpsters" alignment="left" caption="Dumpsters" width="100"></dxi-data-grid-column>

                <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
                <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
                <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
                <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
                <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="storage-dump-site-overview-grid"></dxo-data-grid-state-storing>
                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button class="btn btn-success me-2 mb-2" (click)="open()">Add</button>
                    <button
                        class="btn btn-primary me-1 mb-2"
                        (click)="open(overviewGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="overviewGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Edit
                    </button>
                    <button
                        class="btn btn-danger me-4 mb-2"
                        (click)="delete(overviewGrid.instance.getSelectedRowsData())"
                        [disabled]="overviewGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Delete
                    </button>
                    <button
                        class="btn btn-secondary mb-2"
                        (click)="assignDumpsters(overviewGrid.instance.getSelectedRowsData())"
                        [disabled]="overviewGrid.instance.getSelectedRowsData().length === 0"
                    >
                        Assign Dumpsters
                    </button>
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
